import { BlueberryPediatricsPage } from "#/pages/telemedicine/blueberry-pediatrics/page"
import { MedicalPrimePage } from "#/pages/telemedicine/medical-prime/page"
import { Paths } from "#/utils/Paths"
import { OriginPage } from "#/pages/telemedicine/origin/page"

export const ContentfulControlledPageRoutes = [
  {
    path: Paths.TELEMEDICINE_FOR_PEDIATRICS,
    component: BlueberryPediatricsPage
  },
  {
    path: Paths.TELEMEDICINE_FOR_MENOPAUSE_CARE,
    component: MedicalPrimePage
  },
  {
    path: Paths.TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY,
    component: OriginPage
  }
] as const
